import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'jquery-lazy';
import 'jquery-sticky';
import 'jquery.cookie';
// import objs that must be created
import CookieHelper from './components/cookie-helper';
import UTIL from './components/util';
import DisplayTweaks from './components/display-tweaks';
import ImageOverVideo from './components/image-over-video';
import WPMLHelper from './components/wpml-helper';
import Social from './components/social-widget';
import './components/menu';
import SiteCountrySwitcher from './components/site-country-switcher';

window.cookieHelper = new CookieHelper();
window.UTIL = new UTIL();
/* eslint-disable no-new */
new DisplayTweaks(); // don't store in var, just one time changes
window.imageOverVideo = new ImageOverVideo();
new WPMLHelper();
window.social = new Social();
if ($('.js-site-switcher').length) {
    new SiteCountrySwitcher();
}

// Global
// tab control support
const $panels = $('.js-ui-tab-panel');
if ($panels.length) {
    const $tabs = $('.js-ui-tab').on('click', (e) => {
        const tab = e.currentTarget;

        $tabs.removeClass('active');
        $panels.removeClass('active');

        const $this = $(tab).addClass('active');
        const index = $this.parent().children().index(tab);
        $panels.eq(index).addClass('active');

        return false;
    });
}

// lazy loader
// lazy load footer logos
$('.brand-logo').Lazy();

// Content Block support
// Where to Buy Blocks
// Contact Us Blocks
(() => {
    const countryCode = $.cookie('STYXKEY-country');
    let blocksShown = 0;
    if (countryCode && typeof countryCode === 'string') {
        blocksShown = $(`.js-contentblock-country-${countryCode}`).removeClass('hidden').length;
    }
    if (!countryCode || !blocksShown) {
        $('.js-contentblock-default-content').removeClass('hidden');
    }
})();

// show/hide accordions
$('.accordion-content li').keypress((e) => {
    if (e.which === 13) {
        e.preventDefault();
        $(this).children('.title').click();
    }
});

$('.accordion-content .title').click((e) => {
    e.preventDefault();
    $(this).closest('li').find('.content').not(':animated').slideToggle();
    $(this).toggleClass('accordion-expanded');
});

// show/hide modals
$('.close').keypress((e) => {
    if (e.which === 13) {
        e.preventDefault();
        $(this).click();
    }
});

// options page settings for breaker bar
const breakerBarAvailable = $('.js-breaker-bar').length > 0;
if (breakerBarAvailable) {
    // can be turned off by ACF field show_breaker_bar
    // show pink breaker bar if hideBreakerBar cookie isn't set to true
    const breakerBarCookie = 'hideBreakerBar';

    let hideBreakerBar = $.cookie(breakerBarCookie);
    if (!hideBreakerBar || $.isEmptyObject(hideBreakerBar)) {
        hideBreakerBar = false;
    } else {
        hideBreakerBar = JSON.parse(hideBreakerBar);
    }

    if (!hideBreakerBar) {
        $('.js-breaker-bar').show();
        $('svg.js-breaker-close').on('click', () => {
            $('svg.js-breaker-carrot').removeClass('rotate');
            $('.js-breaker-bar').hide();
            // set cookie to hide it on subsequent requests for current session
            // use date to possibly handle updates in the future
            $.cookie(breakerBarCookie, JSON.stringify(new Date()), {
                path: '/',
            });
        });
        $('.js-breaker-bar').on('click', () => {
            if ($('#js-breaker-bar-main-text').is(':visible')) {
                $('svg.js-breaker-close').click();
            } else {
                $('svg.js-breaker-carrot').addClass('hidden');
                $('svg.js-breaker-close').removeClass('hidden');
                $('#js-breaker-bar-main-text').show();
            }
        });
    }
}

(async () => {
    const pathname = translatedStrings.en_pathname;
    const bodyID = document.body.id;
    const { classList } = document.body;

    // home page
    if (bodyID === 'home' || bodyID === 'accueil') {
        await import(
            /* webpackChunkName: "slick-carousel" */
            'slick-carousel'
        );
        await import(
            /* webpackChunkName: "home" */
            './pages/home'
        );
    }
    // product landing page with & without categories
    if (pathname.match(/\/products\/$/) || pathname.match(/.*\/product_category\/.*/)) {
        await import(
            /* webpackChunkName: "products" */
            './pages/products'
        );
    }

    // Product detail page
    if (classList.contains('single-product')) {
        // threesixty depends on jquery-migrate 1.4.1
        await import(
            /* webpackChunkName: "jquery-migrate" */
            'jquery-migrate'
        );
        await import(
            /* webpackChunkName: "threesixty" */
            './plugins/threesixty'
        );
        await import(
            /* webpackChunkName: "slick-carousel" */
            'slick-carousel'
        );
        await import(
            /* webpackChunkName: "single-product" */
            './pages/single-product'
        );
    }

    // how-to details page
    if (pathname.indexOf('/how-to/') !== -1) {
        await import(
            /* webpackChunkName: "single-tips" */
            './pages/single-tips'
        );
    }

    if (document.querySelector('.js-product-finder')) {
        await import(
            /* webpackChunkName: "product-finder" */
            './components/modules/product-finder'
        );
    }

    if (classList.contains('search-results') || classList.contains('search-no-results')) {
        await import(
            /* webpackChunkName: "search-results" */
            './pages/search-results'
        );
    }

    if (pathname === '/our-purpose/clean-facts/') {
        await import(
            /* webpackChunkName: "clean-facts" */
            './pages/clean-facts'
        );
    }

    // scentiva page
    if (pathname === '/scentiva/') {
        await import(
            /* webpackChunkName: "scentiva" */
            './pages/scentiva'
        );
    }

    if (pathname === '/bleach-can-clean-and-disinfect-that-and-more/') {
        await import(
            /* webpackChunkName: "bleach-can-clean-and-disinfect-that-and-more" */
            './pages/bleach-can-clean-and-disinfect-that-and-more'
        );
        await import(
            /* webpackChunkName: "video-popup" */
            './components/video-popup'
        );
    }
})();